import React from 'react';
import { Hero } from './components/Hero';
import { StatsStrip } from './components/StatsStrip';
import { TopTestimonials } from './components/TopTestimonials';
import { PainPoints } from './components/PainPoints';
import { ProductOverview } from './components/ProductOverview';
import { Modules } from './components/Modules';
import { Bonuses } from './components/Bonuses';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { CoachTestimonials } from './components/CoachTestimonials';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { Comparison } from './components/Comparison';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
import { useMetaPixel } from './hooks/useMetaPixel';
const META_PIXEL_ID = '924467303717674';
export function App() {
  useMetaPixel(META_PIXEL_ID);
  return <div className="w-full bg-navy-800 font-sans" data-id="element-0" data-mp="23ujl6el5pr4k">
      <Hero data-id="element-1" data-mp="3ik7gwiph6frp" />
      <main data-id="element-2" data-mp="3ikhaeg9qb525">
        <StatsStrip data-id="element-3" data-mp="3iiwdijzxza14" />
        <TopTestimonials data-id="element-4" data-mp="3ijfw82xf22g7" />
        <PainPoints data-id="element-5" data-mp="3ii4su47vuwpm" />
        <ProductOverview data-id="element-6" data-mp="3mlaxx8j9ehui" />
        <Modules data-id="element-7" data-mp="3mkhmhu9cv461" />
        <Bonuses data-id="element-8" data-mp="3mjzs7369700r" />
        <Urgency data-id="element-9" data-mp="3mjgannkimdn9" />
        <Pricing data-id="element-10" data-mp="3rc9du70c5dx8" />
        <CoachTestimonials data-id="element-11" data-mp="3rbra6pbcfxfa" />
        <Guarantee data-id="element-12" data-mp="3rdkisa5iorpx" />
        <Faq data-id="element-13" data-mp="3rd19tixuhdo1" />
        <Comparison data-id="element-14" data-mp="3reltuemj9e7n" />
      </main>
      <Footer data-id="element-15" data-mp="6hovayao7c0" />
      <StickyCta data-id="element-16" data-mp="4wv3njt0sf7" />
    </div>;
}